var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoxBackDisabled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_216",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box_back_disabled",
    transform: "translate(-3612 -1824)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3612, 1824)",
    filter: "url(#Rectangle_216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_216-2",
    "data-name": "Rectangle 216",
    transform: "translate(9 6)",
    fill: "#fff",
    stroke: "rgba(191,191,191,0.5)",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 29.5,
    height: 29.5,
    rx: 4.75,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "left_back",
    d: "M97.354,6.594l4.526,5.16a.675.675,0,0,0,1.042,0,.926.926,0,0,0,0-1.188L98.918,6l4-4.565a.926.926,0,0,0,0-1.188.675.675,0,0,0-1.042,0l-4.526,5.16a.926.926,0,0,0,0,1.188Z",
    transform: "translate(3535.861 1839)",
    fill: "rgba(16,55,78,0.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxBackDisabled);
export default __webpack_public_path__ + "static/media/box_back_disabled.ada552b14b8d690a7396b419f06bcf52.svg";
export { ForwardRef as ReactComponent };